import { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const BeforeAfterSlider = ({ project }) => {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);

  const handleMove = (e) => {
    if (!isDragging && e?.type !== 'click') return;
    
    const container = e?.currentTarget?.getBoundingClientRect();
    const x = (e?.type?.includes('mouse') ? e?.clientX : e?.touches?.[0]?.clientX) - container?.left;
    const percentage = Math.max(0, Math.min(100, (x / container?.width) * 100));
    setSliderPosition(percentage);
  };

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="p-4 md:p-6 border-b border-border">
        <h3 className="font-headline font-semibold text-foreground text-lg md:text-xl mb-2">
          {project?.title}
        </h3>
        <p className="text-muted-foreground text-sm md:text-base font-body">
          {project?.description}
        </p>
        <div className="flex flex-wrap gap-2 mt-3">
          <span className="px-3 py-1 rounded-full text-xs md:text-sm font-medium bg-primary/10 text-primary">
            {project?.serviceType}
          </span>
          <span className="px-3 py-1 rounded-full text-xs md:text-sm font-medium bg-muted text-muted-foreground">
            {project?.duration}
          </span>
        </div>
      </div>
      <div 
        className="relative w-full aspect-[4/3] cursor-ew-resize select-none"
        onMouseDown={() => setIsDragging(true)}
        onMouseUp={() => setIsDragging(false)}
        onMouseLeave={() => setIsDragging(false)}
        onMouseMove={handleMove}
        onTouchStart={() => setIsDragging(true)}
        onTouchEnd={() => setIsDragging(false)}
        onTouchMove={handleMove}
        onClick={handleMove}
      >
        <Image
          src={project?.afterImage}
          alt={project?.afterImageAlt}
          className="absolute inset-0 w-full h-full object-cover"
        />
        
        <div 
          className="absolute inset-0 overflow-hidden"
          style={{ clipPath: `inset(0 ${100 - sliderPosition}% 0 0)` }}
        >
          <Image
            src={project?.beforeImage}
            alt={project?.beforeImageAlt}
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>

        <div 
          className="absolute top-0 bottom-0 w-1 bg-white shadow-lg"
          style={{ left: `${sliderPosition}%` }}
        >
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-white rounded-full shadow-elevated flex items-center justify-center">
            <Icon name="ChevronsLeftRight" size={20} className="text-primary" />
          </div>
        </div>

        <div className="absolute top-4 left-4 bg-error text-error-foreground px-3 py-1 rounded-full text-xs md:text-sm font-semibold">
          BEFORE
        </div>
        <div className="absolute top-4 right-4 bg-success text-success-foreground px-3 py-1 rounded-full text-xs md:text-sm font-semibold">
          AFTER
        </div>
      </div>
      <div className="p-4 md:p-6 bg-muted/30">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <p className="text-xs text-muted-foreground mb-1 font-body">Problem</p>
            <p className="text-sm md:text-base text-foreground font-medium">{project?.problem}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1 font-body">Solution</p>
            <p className="text-sm md:text-base text-foreground font-medium">{project?.solution}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1 font-body">Result</p>
            <p className="text-sm md:text-base text-success font-medium">{project?.result}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeforeAfterSlider;